/** https://github.com/jshttp/cookie */
function startIndex(str: string, i: number, max: number) {
  let index = i;
  while (index < max) {
    const code = str.charCodeAt(index);
    if (code !== 0x20 /*   */ && code !== 0x09 /* \t */) return index;
    index += 1;
  }
  return max;
}
function endIndex(str: string, i: number, min: number) {
  let index = i;
  while (index > min) {
    index -= 1;
    const code = str.charCodeAt(index);
    if (code !== 0x20 /*   */ && code !== 0x09 /* \t */) return index + 1;
  }
  return min;
}
function decode(str: string) {
  if (str.indexOf('%') === -1) return str;
  try {
    return decodeURIComponent(str);
  } catch {
    return str;
  }
}
function parse(str: string) {
  const obj: Record<string, string | undefined> = {};
  const len = str.length;
  // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
  if (len < 2) return obj;
  let index = 0;
  do {
    const eqIdx = str.indexOf('=', index);
    if (eqIdx === -1) break; // No more cookie pairs.
    const colonIdx = str.indexOf(';', index);
    const endIdx = colonIdx === -1 ? len : colonIdx;
    if (eqIdx > endIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1;
    } else {
      const keyStartIdx = startIndex(str, index, eqIdx);
      const keyEndIdx = endIndex(str, eqIdx, keyStartIdx);
      const key = str.slice(keyStartIdx, keyEndIdx);
      // only assign once
      if (obj[key] === undefined) {
        const valStartIdx = startIndex(str, eqIdx + 1, endIdx);
        const valEndIdx = endIndex(str, endIdx, valStartIdx);
        const value = decode(str.slice(valStartIdx, valEndIdx));
        obj[key] = value;
      }
      index = endIdx + 1;
    }
  } while (index < len);
  return obj;
}

const pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
const domainValueRegExp =
  /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
function serialize(
  name: string,
  val: string,
  options: {
    domain?: string;
    path?: string;
    expires?: Date;
    maxAge?: number;
  }
) {
  if (!cookieNameRegExp.test(name)) {
    throw new TypeError(`argument name is invalid: ${name}`);
  }
  const value = encodeURIComponent(val);
  let str = `${name}=${value}`;

  if (!options) return str;
  if (options.maxAge !== undefined) {
    str += `; Max-Age=${options.maxAge}`;
  }
  if (options.domain) {
    if (!domainValueRegExp.test(options.domain)) {
      throw new TypeError(`option domain is invalid: ${options.domain}`);
    }
    str += `; Domain=${options.domain}`;
  }
  if (options.path) {
    if (!pathValueRegExp.test(options.path)) {
      throw new TypeError(`option path is invalid: ${options.path}`);
    }
    str += `; Path=${options.path}`;
  }
  if (options.expires) {
    str += `; Expires=${options.expires.toUTCString()}`;
  }
  return str;
}

export function loadCookie(name: string) {
  const cookies = parse(document.cookie);
  const cookieVal = cookies[name];

  if (!cookieVal || (cookieVal[0] !== '{' && cookieVal[0] !== '[')) {
    return cookieVal;
  }

  try {
    return JSON.parse(cookieVal);
  } catch {
    return cookieVal;
  }
}

export function saveCookie(
  name: string,
  val: string,
  opt: { path?: string; domain?: string; expires?: Date; maxAge?: number }
) {
  document.cookie = serialize(name, val, opt);
}
